import React, { forwardRef, ComponentClass } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { TaskAttachmentsList } from './attachments';
import { TaskAttachmentsTabs } from './tabs';
import { TaskAttachmentsTitle } from './title';

export type AttachmentsProps = ClassNamePropsWithChildren<
  React.ElementType<HTMLDivElement>
>;

type TaskAttachmentsType = ComponentClass<AttachmentsProps> & {
  List: typeof TaskAttachmentsList;
  Tabs: typeof TaskAttachmentsTabs;
  Title: typeof TaskAttachmentsTitle;
};

const TaskAttachments: TaskAttachmentsType = forwardRef(() => (
  <></>
)) as unknown as TaskAttachmentsType;

TaskAttachments.List = TaskAttachmentsList;
TaskAttachments.Tabs = TaskAttachmentsTabs;
TaskAttachments.Title = TaskAttachmentsTitle;

export { TaskAttachments };

export * from './types';
